import { useConfig } from '@/contexts/ConfigContext';
import { DebugJson, DebugKv, DebugSection } from '../DebugSection';

export interface ConfigSnapshotSectionProps { searchTerm?: string }

export function ConfigSnapshotSection({ searchTerm }: ConfigSnapshotSectionProps): JSX.Element {
  const cfg = useConfig();
  const c = cfg.config as unknown as Record<string, unknown>;

  const counts: Array<{ k: string; v: unknown }> = [];
  let emptyCount = 0;
  for (const key of Object.keys(c)) {
    const v = c[key];
    if (Array.isArray(v)) {
      counts.push({ k: key, v: v.length });
      if (v.length === 0) emptyCount += 1;
    } else if (key === 'notificationTemplates' && v && typeof v === 'object') {
      const env = v as Record<string, unknown>;
      const tmpl = env['templates'];
      const len = Array.isArray(tmpl) ? tmpl.length : 0;
      counts.push({ k: 'notificationTemplates.templates', v: len });
      if (len === 0) emptyCount += 1;
    }
  }
  counts.sort((a, b) => a.k.localeCompare(b.k));

  const meta = [
    { k: 'state', v: cfg.state },
    { k: 'lastLoadedAt', v: cfg.lastLoadedAt?.toISOString() },
    { k: 'error', v: cfg.error },
    { k: 'emptyCatalogs', v: emptyCount },
  ];

  return (
    <DebugSection
      id="config"
      title="6. Config snapshot"
      count={counts.length}
      searchTerm={searchTerm}
    >
      <div className="pcb-debug-subhead">load state</div>
      <DebugKv rows={meta} searchTerm={searchTerm} />
      <div className="pcb-debug-subhead">catalog counts</div>
      <DebugKv rows={counts} searchTerm={searchTerm} />
      <details className="pcb-debug-details">
        <summary>systemSettings</summary>
        <DebugJson value={cfg.config.systemSettings} searchTerm={searchTerm} />
      </details>
    </DebugSection>
  );
}
